import Header from 'modules/header/wholesaler/main';
import React from 'react';
import {useNavigate} from 'react-router-dom';

const RulesWrapper = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header title="قوانین و مقررات" />
      <div className="flex flex-col w-full gap-4 text-gray-6 text-sm pb-5">
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">مقدمه</h5>
          <p className="text-justify	 leading-6">
            سامانه هوشمند مزرعه در خدمت شماست. در مزرعه اطلاعات، تحلیل‌ها و
            پیش‌آگاهی‌های مربوط به هواشناسی، حدنگاری، آفات، قیمت‌ها، دورسنجی،
            شاخص‌های مالی و ... را مشاهده ‌کنید. با داشتن تحلیل‌های به هنگام،
            شما در زمان تصمیم‌گیری برای انتخاب کشت، تامین نهاده و بازاریابی
            محصول از اطلاعات کامل برخوردار هستید. بنابراین، می‌توانید با مشخص
            کردن موقعیت جغرافیایی مزرعه یا کسب و کار خود در دستیار هوشمند مزرعه
            بر اساس دقیق‌ترین اطلاعات و تحلیل‌ها، در زمان مناسب تصمیم‌گیری کنید
            و ریسک فعالیت‌های خود را مدیریت کنید.
          </p>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">درباره ما</h5>
          <p className="text-justify	 leading-6">
            سامانه هوشمند مزرعه محصول شرکت آینده پژوهان لوتوس به شماره ثبت
            558053 و به شماره مجوز فعالیت 21015345 سازمان نظام صنفی رایانه‌ای
            استان تهران است که خدمات خود در آدرس mazraeapp.com ارائه می‌کند.
          </p>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">تعاریف و اصطلاحات</h5>
          <p className="text-justify	 leading-6">
            شرکت: آینده پژوهان لوتوس که در این سند "ما" نامیده می‌شود. مزرعه:
            نام تجاری استارت آپ شرکت آینده پژوهان لوتوس است. حساب کاربری: حسابی
            است که افراد با نقش‌های مختلف برای استفاده از خدمات در اپلیکیشن
            مزرعه ایجاد کرده‌اند. کاربر(ان): شخصی است که با فناوری ارتباطی به
            اپلیکیشن مزرعه متصل است و در این سند "شما" نامیده می‌شود. مشتری:
            افرادی که در اپلیکیشن مزرعه اعلام نیاز به خدمات کرده‌اند و برای
            دریافت آن خدمات پرداخت می‌کنند. تولیدکننده: کشاورزان در حوزه‌های
            تولیدی مختلف زراعی، باغی، دامی و آبزیان تامین کننده: تامین کننده
            خدمات و کالا برای کشاورز در زمینه نهاده‌های پایه و واسطه، نیروی کار
            و ماشین‌آلات خریدار عمده (عمده‌فروش): افرادی حقیقی یا حقوقی خریدار
            عمده محصولات کشاورزی متخصص: کارشناسان با تخصص‌های مختلف و با تایید
            مزرعه برای انجام خدمات مشاوره‌ای کشاورزی اعتبار: مبلغی است که
            کاربران در حساب کاربری خود جهت استفاده از خدمات مزرعه دارند. زنجیره
            تامین: سیستمی متشکل از سازمان‌ها، افراد، فعالیت‌ها، اطلاعات و منابعی
            است که در عرضه یک محصول یا خدمت دخیل هستند.
          </p>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">حساب کاربری</h5>
          <ul>
            <li className="text-justify	leading-6">
              کاربر با ثبت نام در مزرعه می‌پذیرد که قوانین و مقررات را به صورت
              کامل مطالعه کرده و پذیرفته است. این قوانین ممکن است در طول زمان
              تغییر کند، استفادۀ مستمر کاربران از اپلیکیشن مزرعه به معنی پذیرش
              هرگونه تغییر در قوانین و مقررات آن است. البته تغییر در قوانین و
              مقررات توسط شرکت به اطلاع کاربران می‌رسد.
            </li>
            <li className="text-justify	leading-6">
              برای استفاده از اپلیکیشن مزرعه لازم است که هر کاربر یک حساب کاربری
              متناسب با نقش خود در مزرعه بسازد. تنها افرادی که بیش از ۱۸ سال سن
              و واجد اهلیت قانونی باشند می‌توانند اقدام به ساختن حساب کاربری
              مزرعه کنند. برای استفاده از مزرعه کاربر باید نام، نام خانوادگی،
              آدرس، مختصات و شماره همراه خود را در نرم‌افزار مزرعه ثبت کند.
              کاربر می‌پذیرد اطلاعات خواسته شده را درست و به‌ روز در اپلیکیشن
              مزرعه وارد کند.
            </li>
            <li className="text-justify	leading-6">
              هر فرد تنها می‌تواند یک حساب کاربری با یک نقش کاربری در مزرعه
              داشته باشد. مسئولیت همۀ فعالیت‌هایی که از طریق حساب کاربری اشخاص
              در مزرعه یا سایر خدمات مربوط به مزرعه انجام می‌شود بر عهدۀ کاربر
              است. مسئولیت حفظ امنیت اطلاعات حساب کاربری از جمله نام کاربری و
              رمز عبور به عهدۀ کاربر است. در صورت مفقود یا سرقت اطلاعات حساب
              کاربری، کاربر موظف است در اسرع وقت موضوع را به اطلاع شرکت برساند.
              بدیهی است تا زمانی که اطلاع‌رسانی به شرکت انجام نشده است مسئولیت
              همۀ فعالیت‌هایی که از طریق حساب کاربری مذکور انجام شده و می‌شود به
              عهدۀ کاربر خواهد بود.
            </li>
            <li className="text-justify	leading-6">
              کاربر حق ندارد به اشخاص حقیقی و حقوقی دیگر اجازه استفاده از حساب
              کاربری خود را بدهد یا حساب خود را به فرد حقیقی یا حقوقی دیگری
              منتقل کند. در شرایط خاصی ممکن است از کاربر برای استفاده از خدمات،
              درخواست احراز هویت شود، در چنین شرایطی اگر کاربر اطلاعات کافی در
              اختیار شرکت قرار ندهد، شرکت می‌تواند حساب کاربری وی را مسدود کرده
              و از ارائه خدمات به کاربر خودداری کند.
            </li>
            <li className="text-justify	leading-6">
              شایان ذکر است که ایجاد حساب کاربری برای موقعیت مزرعه یا کسب و کاری
              که در تملک یا اجاره کاربر نباشد ممنوع است و شرکت می‌تواند برای
              اعتبارسنجی این موضوع از ابزارهای مستقیم و غیرمستقیم در دسترس
              استفاده نماید، کاربر هم در این زمینه ملزم به همکاری خواهد بود.
              همچنین جبران خسارت و ضرر و زیان ناشی از ایجاد حساب کاربری جعلی به
              شرکت و اشخاص ثالث متوجه کاربر خواهد بود و با تقویم و تایید مراجع
              ذیصلاح باید پرداخت شود.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">مسئولیت کاربران</h5>
          <p className="text-justify	 leading-6">
            مسئولیت همۀ اقدامات کاربران که ناشی از عدم رعایت قوانین موضوعه کشور
            ایران، برعهدۀ شخص متخلف بوده و مزرعه هیچ گونه مسئولیتی در قبال
            اقدامات فوق نداشته و نخواهد داشت و مزرعه می‌تواند ضمن غیر فعال کردن
            حساب متخلف، از طریق مراجع صالح اقدامات قانونی را علیه نامبرده نسبت
            به احقاق حقوق قانونی خود و دیگران بعمل آورد. مسئولیت رعایت همۀ
            قوانین و مقررات کشوری برعهدۀ کاربران است.
          </p>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">
            شما به عنوان کاربر مزرعه با هر نقشی می‌پذیرید که از موارد زیر پیروی
            کنید:
          </h5>
          <ul>
            <li className="text-justify	leading-6">
              داده‌ها، اطلاعاتی و گزارش‌هایی که از طریق این اپلیکیشن در اختیار
              شما قرار می‌گیرد شامل قیمت‌ها، نقشه‌ها، نمودارها، توصیه‌ها،
              هشدارها، دستورالعمل‌ها و سایر اطلاعاتی فنی و مالی که به هر نحو
              بدست می‌آورید، فقط جنبه مشاوره داشته و مسئولیت اجرا و عدم اجرای
              آن‌ها به طور کامل بر عهده خودتان است. در صورت وارد آمدن خسارت یا
              ضرر و زیان مادی و معنوی هیچ مسئولیتی بر عهده سامانه مزرعه و شرکت
              آینده پژوهان لوتوس نیست.
            </li>
            <li className="text-justify	leading-6">
              استفاده از گذرواژه شما توسط هر شخصی حقیقی و حقوقی دیگر ممکن است
              منجر به لغو سریع دسترسی شما شود.
            </li>
            <li className="text-justify	leading-6">
              شما متعهد می‌شوید که وظیفه بروزرسانی کردن اطلاعات شخصی خود در حساب
              کاربری را به عهده بگیرید و ما هیچ مسئولیتی در قبال این موضوع
              نخواهیم داشت.
            </li>

            <li className="text-justify	leading-6">
              شما متعهد می‌شوید که زمین یا کسب و کاری (کالا و خدمات) را که ثبت و
              اطلاعات آن را وارد می‌نمایید، در مالکیت رسمی و قانونی شما قرار
              داشته است و یا وکالت رسمی یا مجوز مکتوب مالک را برای بهره برداری
              در اختیار دارید.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">
            استفاده از وبسایت و مطالب آن در موارد زیر غیر مجاز و ممنوع است:
          </h5>
          <ul>
            <li className="text-justify	leading-6">برای اهداف غیر قانونی</li>
            <li className="text-justify	leading-6">
              برای مجبور کردن دیگران به جهت مشارکت در امور غیر قانونی
            </li>
            <li className="text-justify	leading-6">
              برای نقض مقررات داخلی و بین المللی
            </li>
            <li className="text-justify	leading-6">
              برای نقض حقوق مالکیت فکری وبسایت و حقوق مالکیت فکری دیگران
            </li>
            <li className="text-justify	leading-6">
              برای ارسال اطلاعات نادرست یا گمراه کننده
            </li>
            <li className="text-justify	leading-6">
              برای آپلود یا انتقال ویروس‌ها و یا هر نوع دیگر از کدهای مخرب که بر
              عملکرد خدمات وبسایت ما، وبسایت‌های دیگر و یا اینترنت تأثیر
              می‌گذارد.
            </li>
            <li className="text-justify	leading-6">
              برای جمع‌آوری یا ردیابی اطلاعات شخصی دیگران و استفاده غیر مجاز از
              آن
            </li>
            <li className="text-justify	leading-6">
              برای هر هدف ناخوشایند یا غیر اخلاقی
            </li>
            <li className="text-justify	leading-6">
              برای دخالت در سرویس‌های امنیتی
            </li>
          </ul>
          <p className="text-justify	 leading-6">
            این حق برای ما محفوظ است که به دسترسی و استفاده شخص برای این قبیل
            موارد پایان دهیم.
          </p>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">شرایط خرید خدمات</h5>
          <ul>
            <li className="text-justify	leading-6">
              برای استفاده از خدمات وبسایت باید هزینه خرید تعیین شده در وبسایت
              برای خدمات مورد نظر را بپردازید.
            </li>
            <li className="text-justify	leading-6">
              پرداخت هزینه خرید ممکن است از طریق واریز مستقیم به حساب یا یکی از
              ارائه‌دهندگان درگاه‌های پرداخت تأیید شده در وبسایت صورت بگیرد. شما
              تضمین می‌کنید که برای استفاده از خدمات وبسایت با این خدمات به طور
              کامل آشنایی دارید و محدودیت‌های ناشی از شرایط و ضوابط مورد
              استفاده، سیاست حریم خصوصی و سایر مستندات قانونی دیگر را که به
              وسیله درگاه‌های پرداخت ایجاد می‌شوند، می‌پذیرید.
            </li>
            <li className="text-justify	leading-6">
              بعد از پرداخت، شما تأییدیه‌ای دریافت خواهید کرد که نشان‌دهنده این
              است که پرداخت شما توسط ما دریافت شده است و ممکن است ما جزئیات خرید
              را برای استفاده در آینده ضبط کنیم.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">ضمانتنامه</h5>
          <ul>
            <li className="text-justify	leading-6">
              محصولات و خدمات مزرعه با تضمین‌هایی که مطابق قوانین حمایت از مصرف
              کننده این کشور است، ارائه می‌شود. کاربران حق دارند که جایگزین یا
              بازپرداختی برای خرابی عمده محصول یا خدمات دریافتی داشته باشند.
              هم‌چنین حق دارند که اگر محصولات و خدمات از کیفیت قابل قبول
              برخوردار نبود، از ما بخواهید که خدمات را جایگزین یا وجه را مسترد
              کنیم.
            </li>
            <li className="text-justify	leading-6">
              کاربران می‌توانند تحت این ماده ادعای ضمانت را در مورد محصولات یا
              خدماتی که مشکل دارند، از تاریخ خرید شروع دوره ضمانت مطرح کنند.
            </li>
            <li className="text-justify	leading-6">
              جایی که ادعای تضمین محصولات و خدمات پذیرفته شده است، این شرکت با
              صلاحدید خود، همه محصولات و خدمات یا بخشی از محصولات و خدمات معیوب
              خود را با معیار جدید در طول دوره ضمانت جایگزین می‌کند و به هیچ وجه
              برای این کار از کاربر هزینه‌ای دریافت نمی‌کند. کاربر می‌پذیرد که
              به تنهایی مسئول هزینه‌های حمل و نقلی هستید که در راستای تسهیلات
              ادعای ضمانت ایجاد می‌شود.
            </li>
            <li className="text-justify	leading-6">
              ضمانتنامه هیچ‌گاه نسبت به موارد زیر اعمال نمی‌شود:
            </li>
            <li className="text-justify	leading-6">
              درباره خدمات پیش‌بینی که ماهیت آن با خطا همراه هست.
            </li>
            <li className="text-justify	leading-6">
              درباره هرگونه معامله و مبادله کالا و خدمات که خارج از چارچوب و
              ضوابط سامانه مزرعه باشد.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">تحویل</h5>
          <p className="text-justify	 leading-6">
            کاربران می‌پذیرند که تحویل محصول و خدمات از طریق اپلیکیشن یا دیگر
            راه‌های ارتباطی با سامانه مزرعه شامل ابزارهای هوشمند، پیام‌رسان‌ها،
            ایمیل، پیامک و تلفن انجام می‌شود. در ارائه خدمات، ممکن است شرکت
            گزینه‌های مختلف تحویل را توسط ارائه‌دهندگان خدمات تحویل پیشنهاد دهد.
            کاربر می‌پذیرد که شرکت صرفاً تسهیل‌ کننده تعامل شما با ارائه‌دهندگان
            خدمات تحویل هست و لذا در قبال هیچ گونه خسارت، آسیب، از دست دادن سود،
            فرصت یا خسارت به حسن نیت که ناشی از خدمات تحویل یا در ارتباط با آن
            است، در برابر کاربران مسئولیتی ندارد.
          </p>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">کپی رایت و مالکیت معنوی</h5>
          <p className="text-justify	 leading-6">
            وبسایت، اپلیکیشن، خدمات و همه محصولات مرتبط با این شرکت موضوع کپی
            رایت هستند. مطالب و موضوعات وبسایت (از جمله نوشته‌ها، عکس‌ها
            ویدیوها، لوگوها و صداها) ذیل قانون این کشور و معاهدات بین المللی تحت
            حمایت کپی رایت قرار می‌گیرند.. این شرکت همه حقوق و منافع مرتبط با
            وبسایت را حفظ می‌کند:
          </p>
          <ul>
            <li className="text-justify	leading-6">
              نام کسب و کار، نام تجاری، نام و آدرس سایت، علامت تجاری، طرح صنعتی،
              ثبت اختراع و کپی رایت این شرکت
            </li>
            <li className="text-justify	leading-6">
              حق استفاده از نام کسب و کار، نام تجاری، طرح صنعتی، علامت تجاری و
              حقوق مالکیت فکری که در قوانین کشور ایران و مجامع بین المللی به
              رسمیت شناخته شده است با یا بدون قابلیت ثبت آن حقوق
            </li>
          </ul>
          <p className="text-justify	 leading-6">
            کاربران بدون اجازه کتبی این شرکت و اجازه هر صاحب حق دیگری مجاز به
            انجام موارد زیر نیستند:
          </p>
          <ul>
            <li className="text-justify	leading-6">
              پخش، انتشار مجدد، آپلود کردن، انتقال، ارسال، توزیع، نمایش یا پخش
              در عموم بدون درج نشان تجاری مزرعه این ممنوعیت به مواد موجود در
              وبسایت که آزادانه برای استفاده مجدد در دسترس هستند یا در حوزه
              عمومی هستند، گسترش نمی‌یابد.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">حریم خصوصی</h5>
          <p className="text-justify	 leading-6">
            این شرکت حریم خصوصی شما را موضوعی جدی تلقی می‌کند و هر گونه اطلاعاتی
            که از طریق استفاده شما از برنامه و یا خدمات ارائه شده است، به سیاست
            حفظ حریم خصوصی این شرکت مربوط می‌شود که در برنامه موجود است.
          </p>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">سلب مسئولیت عمومی</h5>
          <ul>
            <li className="text-justify	leading-6">
              این شرکت هیچ گونه ضوابط، ضمانت، نمایندگی‌ها یا شرایطی را در رابطه
              با دیگر محصولات به غیر از موارد مطابق با این شرایط و ضوابط ایجاد
              نمی‌کند.
            </li>
            <li className="text-justify	leading-6">
              این شرکت هر گونه تلاش برای اطمینان از اینکه محصول و خدمات دقیقا در
              وبسایت نشان داده می‌شود، به کار می‌گیرد هر چند که اندازه، رنگ و
              بسته‌بندی ممکن است با آنچه که در وبسایت نمایش داده شده، متفاوت
              باشد. این شرکت تمام تلاش خود را به کار می‌گیرد که تا جایی که مقدور
              است تصویر و رنگ محصولات را دقیق نشان دهد ولی نمی‌تواند دقیق بودن
              صفحه نمایش سیستم شما را تضمین کند و در صورت مغایرت مسئولیتی به
              عهده ما نیست. هم‌چنین ما تضمین نمی‌کنیم که کیفیت محصولات، خدمات و
              اطلاعات کاربران زنجیره تامین دقیقا مطابق انتطارات شما باشد.
            </li>
            <li className="text-justify	leading-6">
              هیچ چیز در این شرایط و ضوابط محدود نمی‌شود مگر آن که به موجب قانون
              ممنوع و محدود شده باشد.
            </li>
            <li className="text-justify	leading-6">
              با توجه به این بند و تا حدی که توسط قانون مجاز است:
              <ul>
                <li className="text-justify	leading-6">
                  تمام شرایط، تضمین‌ها، ضمانتنامه‌ها، نمایندگی‌ها یا شرایطی که
                  به طور واضح در این شرایط بیان نشده‌اند، حذف می‌شوند.
                </li>
                <li className="text-justify	leading-6">
                  این شرکت مسئولیتی در قبال موارد زیر نخواهد داشت:
                  <ol>
                    <li className="text-justify	leading-6">
                      هر گونه خسارت یا آسیب مگر این که این زیان یا آسیب قابل
                      پیش‌بینی باشد و یا در نتیجه ناتوانی این شرکت در حمایت از
                      کاربر رخ داده باشد.
                    </li>
                    <li className="text-justify	leading-6">
                      از دست رفتن سود یا فرصت یا آسیب به حسن نیت که ناشی از یا
                      در ارتباط با خدمات وبسایت یا این ضوابط و شرایط است.
                    </li>
                  </ol>
                </li>
              </ul>
            </li>
            <li className="text-justify	leading-6">
              ریسک‌ها و خطرات استفاده از وبسایت، خدمات و هر یک از محصولات این
              شرکت (به همراه خدمات تحویل) به عهده خود شخص است. همه چیز در
              وبسایت، خدمات و محصولات این شرکت، بر اساس"همانطور که هست" و "به
              صورت موجود" ارائه می‌شود.
            </li>
            <li className="text-justify	leading-6">
              قیمت محصولات و خدمات بدون اطلاع رسانی قبلی می‌تواند تغییر کند و در
              این مورد وبسایت مسئولیتی در برابر کاربران نخواهد داشت.
            </li>
            <li className="text-justify	leading-6">
              امکان تغییر یا قطع سرویس در هر زمانی بدون اطلاع رسانی قبلی امکان
              پذیر است و در این مورد وبسایت مسئولیتی در برابر کاربران نخواهد
              داشت
            </li>
            <li className="text-justify	leading-6">
              این شرکت این حق را دارد که فروش محصولات یا خدمات را به هر کس یا
              منطقه خاص جغرافیایی محدود کند و این حق را ممکن است براساس ملاحظات
              موردی انجام دهد و در این مورد مسئولیتی نخواهد داشت.
            </li>
            <li className="text-justify	leading-6">
              این شرکت تضمین و تایید نمی‌کند که استفاده شما از خدمات وبسایت بدون
              وقفه، به موقع، امن و بدون خطا است. و در این مورد مسئولیتی به عهده
              این شرکت نیست.
            </li>
            <li className="text-justify	leading-6">
              این شرکت تضمین و تایید نمی‌کند که استفاده شما از خدمات وبسایت بدون
              وقفه، به موقع، امن و بدون خطا است. و در این مورد مسئولیتی به عهده
              این شرکت نیست.
            </li>
            <li className="text-justify	leading-6">
              ممکن است اطلاعاتی در وبسایت و یا در خدمات وجود داشته باشد که همراه
              با خطاها و اشتباهاتی باشد و یا اینکه اشکالاتی مرتبط یا توضیحات
              محصولات و یا در قسمت درخواست‌ها وجود داشته باشد. این حق برای این
              شرکت محفوظ است که این اشتباهات و اشکالات را برطرف کرده و این موارد
              را تغییر داده و بروزرسانی کند و حتی ممکن است درخواستی را به جهت
              وجود این اشکالات بدون اطلاع قبلی رد کند و از این جهت مسئولیتی
              متوجه این شرکت نیست.
            </li>
            <li className="text-justify	leading-6">
              این اطلاعات و به بروزرسانی‌ها را هر جا که نیاز باشد، مطابق با
              قانون انجام می‌دهیم.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">محدودیت مسئولیت</h5>
          <ul>
            <li className="text-justify	leading-6">
              مسئولیت کل این شرکت ناشی از یا در ارتباط با خدمات یا این شرایط و
              ضوابط است.
            </li>
            <li className="text-justify	leading-6">
              این شرکت هیچ گونه مسئولیتی برای هر محتوایی که در وبسایت یا
              اپلیکیشن مزرعه قرار می‌گیرد یا در ارتباط با خدمات است، ندارد، اعم
              از اینکه توسط کاربران وب سایت، توسط اشخاص ثالث یا توسط هر یک از
              کسانی که خدمات به آن‌ها ارائه شده است، ایجاد یا ارسال شده باشد.
            </li>
            <li className="text-justify	leading-6">
              لینک‌های ثالث موجود در این وبسایت ممکن است مستقیما شما را به
              سایت‌هایی هدایت کند که به این شرکت وابسته نیستند. ما این سایت‌ها
              را تضمین نمی‌کنیم و هیچ مسئولیتی در قبال این سایت‌ها در برابر
              کاربران نداریم. هم‌چنین مسئول ضرر و خسارتی که به واسطه استفاده از
              محصولات، خدمات و یا سایت‌های ثالت وارد می‌شود هم نیستیم.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">خاتمه قرارداد</h5>
          <ul>
            <li className="text-justify	leading-6">
              این شرایط تا زمانی که قرارداد توسط شما یا توسط این شرکت به پایان
              برسد به شرح زیر اعمال خواهد شد.
            </li>
            <li className="text-justify	leading-6">
              اگر شما می‌خواهید که به این شرایط و ضوابط پایان دهید می بایست به
              موارد زیر عمل کنید:
            </li>
            <ul>
              <li className="text-justify	leading-6">
                اطلاع دادن به این شرکت در هر زمان از طریق ثبت درخواست کتبی در
                قسمت ارتباط با ما که در صفحه اصلی وبسایت موجود است.
              </li>
              <li className="text-justify	leading-6">
                بستن حساب‌های شما برای تمام خدماتی که شما استفاده می‌کنید، از
                طریق قسمتی که این شرکت این گزینه را برای شما قرار داده است.
              </li>
            </ul>
            <li className="text-justify	leading-6">
              این شرکت ممکن است در هر زمان این شرایط و ضوابط را با شما خاتمه دهد
              اگر:
            </li>
            <ul>
              <li className="text-justify	leading-6">
                شما هر یک از مقرره‌های این شرایط و ضوابط را نقض کرده‌اید یا قصد
                نقض هر یک از مقررات را دارید.
              </li>
              <li className="text-justify	leading-6">
                زمانی که این شرکت به موجب قانون ناگزیر از این اقدام است.
              </li>
              <li className="text-justify	leading-6">
                شریکی که از طریق او این شرکت خدماتش را به شما ارائه می‌داد به
                رابطه‌اش یا این شرکت خاتمه داده باشد و یا ارائه خدمات خرید را به
                شما متوقف کرده باشد.{' '}
              </li>
              <li className="text-justify	leading-6">
                ارائه خدمات به شما بنا به صلاحدید این شرکت دیگر قابل اعتماد
                نباشد.{' '}
              </li>
            </ul>
            <li className="text-justify	leading-6">
              مطابق با قوانین لازم الاجرا این شرکت این حق را دارد که عضویت شما
              را در وبسایت متوقف یا لغو کند. اگر شما مقررات لازم الاجرا را نقض
              کنید، رفتار شما بر نام یا شهرت این شرکت تاثیر سو بگذارد و یا حقوق
              افراد دیگر را نقض کنید، ممکن است به صلاحدید خود، دسترسی شما را به
              کلیه یا هر بخش وبسایت یا خدمات بدون اطلاع شما متوقف کند.
            </li>
            <li className="text-justify	leading-6">
              هنگامی که التزام طرفین به این شرایط و ضوابط به پایان می‌رسد، تمام
              حقوق قانونی، تعهدات و مسئولیت‌هایی که شما و این شرکت از آن
              برخوردار بوده‌اید، باید با این توقف متوقف شود.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">نظرات کاربران</h5>
          <ul>
            <li className="text-justify	leading-6">
              اگر در هر زمانی بدون درخواست با درخواست ما شما از طریق ایمیل، به
              صورت آنلاین و از هر راه متداول دیگری نظری را ارسال نمایید، این حق
              برای ما محفوظ است که بدون ویرایش و اعمال محدودیت آن را در هر
              رسانه‌ای استفاده کنیم و در برابر این نظرات ملزم به محفوظ نگه
              داشتن، جبران خسارت در صورت فاش شدن و پاسخ به همه آن‌ها نیستیم.
            </li>
            <li className="text-justify	leading-6">
              ما این اختیار را داریم که بنا به صلاحدید خود هر محتوایی را که غیر
              قانونی، تهاجمی، همراه با تهدید، مختل کننده حقوق دیگران و در تضاد
              با این شرایط و ضوابط باشد، ویرایش و یا حذف کنیم.
            </li>
            <li className="text-justify	leading-6">
              شما می‌پذیرید که نظرات‌تان غیر قانونی، تهاجمی، همراه با تهدید و در
              تضاد با حقوق دیگران و این شرایط و ضوابط نباشد. در واقع شما مسئولیت
              هر پیامی را که از طرف شما ارسال می‌شود، به عهده دارید.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">جبران خسارت</h5>
          <p className="text-justify	 leading-6">
            شما می‌پذیرید که در برابر این شرکت، کارکنان، نمایندگی‌ها و تامین
            کنندگان ثالثش در موارد زیر جبران خسارت کنید:
          </p>
          <ul>
            <li className="text-justify	leading-6">
              تمام اقدامات، ادعاها، خواسته‌ها، هزینه‌ها، تلفات و خساراتی که نشات
              گرفته یا ایجاد شده به وسیله یا در ارتباط با هر محتوایی است که از
              طریق وبسایت پست می‌کنید.
            </li>
            <li className="text-justify	leading-6">
              هرگونه پیامد مستقیم یا غیرمستقیم از دسترسی، استفاده یا انجام
              معاملات در وبسایت
            </li>
            <li className="text-justify	leading-6">
              نقض هر یک از موارد این شرایط و ضوابط{' '}
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">حل و فصل اختلافات</h5>
          <p className="text-justify	 leading-6">موارد الزامی</p>
          <ul>
            <li className="text-justify	leading-6">
              - در صورتی که مناقشات ناشی از شرایط و ضوابط یا مربوط به این شرایط
              باشد، هر یک از طرفین با رعایت موارد زیر می‌تواند اقدام به رسیدگی
              قضایی به اختلافات نماید (به جز مواردی که باید امدادرسانی فوری صورت
              بگیرد).
            </li>
          </ul>
          <p className="text-justify	 leading-6">توجه کنید که:</p>
          <ul>
            <li className="text-justify	leading-6">
              - طرفی که ادعا می‌کند اختلافی در ارتباط با این شرایط مطرح شده است،
              باید یک نوشته کتبی به طرف دیگر ارسال کند تا جزئیات ماهیت اختلاف،
              نتیجه مورد نظر و اقدام مورد نیاز برای حل اختلاف را مشخص کند.
            </li>
          </ul>
          <p className="text-justify	 leading-6">طرف مقابل باید:</p>
          <ul>
            <li className="text-justify	leading-6">
              ظرف مدت 30 روز از دریافت اظهارنامه برای حل و فصل اختلافات از طریق
              مذاکره و یا به روش‌های دیگری که با آن‌ها موافقت می‌کنند، اقدام
              کنند.
            </li>
            <li className="text-justify	leading-6">
              اگر به هر دلیلی ظرف مدت 30 روز از تاریخ دریافت اظهارنامه اختلافات
              حل و فصل نشد، دو طرف اختلاف باید یا بر انتخاب داور از طرف خودشان
              توافق کنند و یا درخواست کنند که یک داور مناسب برای آن‌ها تعیین
              شود.
            </li>
            <li className="text-justify	leading-6">
              طرفین به طور برابر در برابر هزینه‌های داوری مسئول هستند.
            </li>
            <li className="text-justify	leading-6">
              مکان حل و فصل اختلافات به وسیله داور نیز باید مشخص شود.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">محرمانگی</h5>
          <ul>
            <li className="text-justify	leading-6">
              تمامی ارتباطات مربوط به مذاکرات که از اختلافات نشات می‌گیرند یا
              مرتبط به آن‌ها هستند، محرمانه می‌باشند و تا حدی که ممکن است این
              مذاکرات باید بدون غرض ورزی صورت بگیرد.
            </li>
            <li className="text-justify	leading-6">
              چنانچه 30 روز از آغاز داوری برای حل و فصل اختلافات به وجود آمده
              سپری شود ولی هم‌چنان اختلاف باقی باشد، در این صورت هر یک از طرفین
              می‌تواند اتمام داوری را خواستار شود و داور نیز ملزم به پذیرش این
              مسئله می‌باشد.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">صلاحیت محلی</h5>
          <p className="text-justify	 leading-6">
            خدمات این وبسایت و اپلیکیشن قابل ارائه به افرادی است که در ایران
            زندگی می‌کنند و لذا در صورت بروز هر گونه اختلاف در ارتباط با این
            وبسایت دادگاه‌های قلمرو این کشور صالح به رسیدگی هستند.
          </p>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <h5 className="font-extrabold text-m">قانون حاکم</h5>
          <ul>
            <li className="text-justify	leading-6">
              شرایط و ضوابط پیش‌رو مطابق با قوانین ایران تنظیم شده‌اند. هر گونه
              اختلاف یا ادعایی که مرتبط با این شرایط و ضوابط باشد، باید بر اساس
              این قانون تفسیر شود و حقوق طرفین و جانشینان آن‌ها نیز باید حل و
              فصل شود.
            </li>
            <li className="text-justify	leading-6">
              هر دو طرف تایید می‌کنند که مفاد این شرایط و ضوابط منصفانه و منطقی
              است و اعلام می‌کنند که این شرایط و ضوابط خلاف سیاست‌های عمومی و به
              صورت نابرابر تنظیم نشده است.
            </li>
            <li className="text-justify	leading-6">
              اگر بخشی از این شرایط و ضوابط براساس حکم دادگاه صلاحیت‌دار غیر
              قابل اجرا تشخیص داده شود، در این صورت تنها همین بخش از ضوابط و
              شرایط جدا شده و باقی مفاد لازم الاجرا باقی می‌ماند.
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-4 px-4">
          <p className="text-justify	 leading-6">
            آخرین ویرایش این ضوابط و مقرارت مربوط به تاریخ 10 تیرماه 1401 است.
          </p>
        </div>
        <div className="flex justify-center w-full">
          <button
            className="w-[70%] rounded-lg text-white py-4  bg-cyan-2 mb-4"
            onClick={() => navigate('/auth/login')}
          >
            باشه
          </button>
        </div>
      </div>
    </>
  );
};

export default RulesWrapper;
